module.exports = __webpack_public_path__ + "static/media/mainHero.de5b21b8.svg";